import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router'

import { PageHeader } from '@/components/page-header'
import { msg } from '@/i18n'
import { cn } from '@/lib/utils'

/** Mon compte, au portail : l'identité, et les notifications (lot 13). */
export const Route = createFileRoute('/portal/compte')({
  component: PortalAccountLayout,
})

const SECTIONS = [
  { to: '/portal/compte', label: 'sectionAccount', exact: true },
  { to: '/portal/compte/notifications', label: 'sectionNotifications' },
] as const

function PortalAccountLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const t = msg().portalAccount
  return (
    <div className="space-y-5">
      <PageHeader title={t.title} documentTitle={t.title} />
      <nav aria-label={t.sections} className="flex gap-1 border-b border-border">
        {SECTIONS.map((section) => {
          const active =
            'exact' in section ? pathname === section.to : pathname.startsWith(section.to)
          return (
            <Link
              key={section.to}
              to={section.to}
              className={cn(
                '-mb-px border-b-2 px-3 py-2 text-sm',
                active
                  ? 'border-primary font-medium text-foreground'
                  : 'border-transparent text-muted-foreground hover:text-foreground',
              )}
            >
              {t[section.label]}
            </Link>
          )
        })}
      </nav>
      <Outlet />
    </div>
  )
}
